import React, { ReactNode, useState } from 'react'
import { InformationIcon } from '@paypalcorp/pp-react'
import './info-card.css'

interface InfoCardProps {
  content: ReactNode
}

export const InfoCard: React.FC<InfoCardProps> = ({ content }) => {
  return (
    <>
      <div className="info_card__container">
        <div className="info_card__wrapper">
          <InformationIcon color="sysColorPrimaryMain" />
          <div className="info_card__content">{content}</div>
        </div>
      </div>
    </>
  )
}
